var _Path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path, Circle } from "react-native-svg";

function SvgMedalStar(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 40,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Path, {
    d: "M5.946 45.98l4.633-10.609c.762.992 3.67 3.184 9.206 4.021L15.152 50l-3.223-5.17-5.983 1.15z",
    fill: props.color
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M32.909 45.98L28.275 35.37c-.761.992-3.669 3.184-9.205 4.021L23.703 50l3.223-5.17 5.983 1.15z",
    fill: props.color
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 20,
    cy: 20,
    r: 19,
    fill: props.color,
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 20,
    cy: 20,
    r: 13.5,
    fill: props.color,
    stroke: props.color
  }), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M20 11l2.02 6.219h6.54l-5.29 3.843 2.02 6.22L20 23.437l-5.29 3.843 2.02-6.219-5.29-3.843h6.54L20 11z",
    fill: "#fff"
  })));
}

export default SvgMedalStar;